/**
 * URLs externas usadas em links de UI (footer, feedback, docs).
 *
 * `VITE_REPO_URL` override permite reapontar quando o repo migra (ex.: pra
 * org GitHub) sem precisar mudar componente por componente. Default cobre o
 * estado atual.
 */
export const REPO_URL =
  (import.meta.env.VITE_REPO_URL as string | undefined) ??
  'https://github.com/alexsandron3/multimod';

export const ISSUES_URL = `${REPO_URL}/issues`;
